import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreativeTemplate } from '../../../../shared/models/creativeTemplate';
import { CreativeTemplateService } from '../../../../shared/services/creativeTemplate.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgeRange } from '../../../models/ageRange';
import { AgeRangeService } from '../../../services/ageRange.service';
import { StoreLocationService } from '../../../services/storelocation.service';
import { StoreLocation } from '../../../models/storeLocation';
import { CampaignType } from '../../../models/CampaignType';
import { CampaignTypeService } from '../../../services/campaignType.service';
import { ValidationService } from '../../../services/validation.service';
import { BrandMonthConversionService } from '../../../services/brandMonthConversion.service';

@Component({
  selector: 'app-creative-template-edit-form',
  templateUrl: './creative-template-edit.component.html'
})

export class CreativeTemplateEditFormComponent implements OnInit { 

  //input/output parameters
  @Input() title;
  @Input() creativeTemplate: CreativeTemplate; 
  //@Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  editForm: FormGroup; 
  submitted = false; 
  public ageRangeList: AgeRange[];  
  public genderList = ['F', 'M'];
  public storeLocationList: StoreLocation[];
  public campaignTypeList: CampaignType[];
  public monthsList: any[];
  public monthsConversionList: any[];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private creativeTemplateService: CreativeTemplateService,
    private ageRangeService: AgeRangeService,
    private storeLocationService: StoreLocationService,
    private notification: MatSnackBar,
    private campaignTypeService: CampaignTypeService,
    private brandMonthConversionService: BrandMonthConversionService) { }

  // on component load
  ngOnInit() {

    // bind campaign types
    this.campaignTypeService.getAll().subscribe(campaignResult => {
      this.campaignTypeList = campaignResult;
    });
     
    // bind age ranges dropdown
    this.ageRangeService.getAll().subscribe(result => {
      this.ageRangeList = result;
    });

    // bind store locations dropdown
    this.storeLocationService.getAll(this.creativeTemplate.brandId).subscribe(result => {
      this.storeLocationList = result;
    });
     
    // get all months
    this.brandMonthConversionService.getAll(this.creativeTemplate.brandId).subscribe(result => {
      this.monthsConversionList = result.filter((x, i, arr) => {
        return arr.indexOf(arr.find(t => t.campaignTypeId === x.campaignTypeId && t.convertMonth === x.convertMonth)) === i;
      }).map(b => ({ campaignTypeId: b.campaignTypeId, months: b.convertMonth }));

      // bind dropdown list for months based on current campaign type id
      this.onChangeCampaignType(this.creativeTemplate.campaignTypeId);
    });

    this.editForm = this.formBuilder.group({
      frontImage: [this.creativeTemplate.frontImage || ''],
      frontCTA: [this.creativeTemplate.frontCTA || ''],
      frontOffer: [this.creativeTemplate.frontOffer || ''],
      frontLogo: [this.creativeTemplate.frontLogo || ''],
      backLogo: [this.creativeTemplate.backLogo || ''],
      backCTA: [this.creativeTemplate.backCTA || ''],
      backBackground: [this.creativeTemplate.backBackground || ''],
      backTopLeftCopy: [this.creativeTemplate.backTopLeftCopy || ''],
      backOfferBlock: [this.creativeTemplate.backOfferBlock || ''],
      backStoreBlock: [this.creativeTemplate.backStoreBlock || ''],
      backBottomLeftCopy: [this.creativeTemplate.backBottomLeftCopy || ''],
      //custom1: [this.creativeTemplate.custom1 || ''],
      //custom2: [this.creativeTemplate.custom2 || ''],
      //custom3: [this.creativeTemplate.custom3 || ''],
      //custom4: [this.creativeTemplate.custom4 || ''],
      //custom5: [this.creativeTemplate.custom5 || ''], 
      gender: [this.creativeTemplate.gender || '', Validators.required],
      months: [this.creativeTemplate.months, [Validators.required, ValidationService.numericValidator]],
      style: [this.creativeTemplate.style || ''],
      brandId: [this.creativeTemplate.brandId || 0],
      campaignTypeId: [this.creativeTemplate.campaignTypeId || 0, [Validators.required, Validators.min(1)]],
      ageRangeId: [this.creativeTemplate.ageRangeId, [Validators.required, Validators.min(1)]],
      //storeLocationId: [this.creativeTemplate.storeLocationId || 0, [Validators.required, Validators.min(1)]]
    });
  }

  // change campaign type
  onChangeCampaignType(campaignTypeId: number) {
    this.monthsList = this.monthsConversionList.filter(x => {
      return x.campaignTypeId === +campaignTypeId;
    });
  }

  // handle form submit 
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.editForm.invalid) {
        return; 
      } 
      const model = this.editForm.value as CreativeTemplate;
      model.brandId = +this.editForm.value['brandId'];
      model.campaignTypeId = +this.editForm.value['campaignTypeId'];
      model.ageRangeId = +this.editForm.value['ageRangeId'];
      model.months = +this.editForm.value['months'];
     // model.storeLocationId = +this.editForm.value['storeLocationId'];
     
      this.creativeTemplateService.update(+this.creativeTemplate.id, model).subscribe(creativeTemplate => {       
        //this.eventEmitter.emit(this.editForm.value);
        this.activeModal.close(true);
        this.showNotification(`The entry was successuly updated!`, 'Okay!') 
      }); 
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
